import { FileApi } from "../../../redux/api/FileApi";
import { FileType } from "../../../types/File/FileType";
import FileUpload from "../../Attachment/FileUpload";


const Attachments: React.FC = (props) => {
    const { data: isFileActive } = FileApi.useIsActiveQuery(FileType.Call_Action_Internal)

    return (
        <div className="content">
            {isFileActive && <FileUpload FileType={FileType.Call_Action_Internal} Primary_Id={0} />}
        </div>
    )
}

export default Attachments;